// Import external
import { CommonModule } from '@angular/common';
import { ErrorHandler, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { UrlSerializer } from '@angular/router';

// Import internal
import { ErrorService } from '@app/services/error.service';
import { NotificationService } from '@app/services/notification.service';
import { UserSessionService } from '@app/services/user-session.service';
import { AvatarService } from '@app/services/avatar.service';
import { GlobalErrorHandler } from '@app/services/error-handler.service';
import { ExternalLinkService } from '@app/services/external-link.service';
import { GravatarService } from '@app/services/gravatar.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SynappsHttpInterceptor } from '@app/interceptors/http.interceptor';
import { UpperCaseUrlSerializer } from '@app/interceptors/url-serializer';
import { AuthGuard } from '@app/guards/auth.guard';
import { UserSessionGuard } from '@app/guards/user-session.guard';
import { HttpErrorComponent } from './components/http-error/http-error.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        HttpErrorComponent,
    ]
})
export class CoreModule {

    // Custom constructor to safe guard against bad imports
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        if (parentModule) {
            throw new Error(
                'CoreModule is already loaded. Import it in the AppModule only');
        }
    }

    static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [
                {provide: ErrorHandler, useClass: GlobalErrorHandler},
                AvatarService,
                ErrorService,
                ExternalLinkService,
                GravatarService,
                NotificationService,
                UserSessionService,
                { provide: HTTP_INTERCEPTORS, useClass: SynappsHttpInterceptor, multi: true },
                { provide: UrlSerializer, useClass: UpperCaseUrlSerializer },
                AuthGuard,
                UserSessionGuard,
            ]
        };
    }
}
